var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-range"},[_c('vue-slider',{attrs:{"tooltip":"always","height":15,"enable-cross":false,"tooltip-placement":['top', 'bottom'],"tooltip-formatter":function (val) { return new Intl.DateTimeFormat(undefined, {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric'
        }).format(new Date(_vm.valueToDate(val))); }},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }